import { trackEvent, trackMutinyConversion, identifyUser, dataLayerPush } from "lib/analytics";

/**
 * Tracking demo link to `/demo` (not form submission)
 */
const trackDemoButtonClicked = () => {
  trackEvent("Demo Button Clicked", {
    page: window.location.href,
  });
};

/**
 * Tracking demo link to `/demo-ai-agents` (not form submission)
 */
const trackAgentsDemoButtonClicked = () => {
  trackEvent("Demo Agents Button Clicked", {
    page: window.location.href,
  });
};

const trackDemoFormSubmitted = (lead: Record<string, string>) => {
  trackEvent("Demo Form Submitted", {
    Email: lead.email,
    "First Name": lead.firstname,
    "Last Name": lead.lastname,
    "Number of Employees": lead.numberofemployees,
  });
  identifyUser({
    email: lead.email,
    firstName: lead.firstname,
    lastName: lead.lastName,
    companyName: lead.company,
  });
  trackMutinyConversion("demo-submitted");
  dataLayerPush("demo_requested");
  window.lintrk?.("track", { conversion_id: 4_947_410 });
};

const trackSignupClicked = () => {
  trackEvent("Sign Up Clicked");
  trackMutinyConversion("sign-up-clicked");
  dataLayerPush("sign_up_clicked");
};

const trackLoginClicked = () => {
  trackEvent("Log In Clicked");
  trackMutinyConversion("log-in-clicked");
  dataLayerPush("log_in_clicked");
};

const trackWhitepaperDownloaded = (fileName: string, lead: Record<string, string>, type: string) => {
  trackEvent("Whitepaper Downloaded", { Email: lead.email, file: fileName, type });
  identifyUser({ email: lead.email });
  trackMutinyConversion("asset-downloaded");
  dataLayerPush("whitepaper_downloaded");
};

const trackNewsletterSignup = (type: string, lead: Record<string, string>) => {
  trackEvent("Newsletter Signup", {
    Type: type,
    Email: lead.email,
    "First Name": lead.firstname,
    "Last Name": lead.lastname,
  });
  identifyUser({
    email: lead.email,
    firstName: lead.firstname,
    lastName: lead.lastName,
  });
  trackMutinyConversion("newsletter-signup");
  dataLayerPush("newsletter_signup");
};

const trackDemoEmbedOpened = (demoId: string, demoName: string) => {
  trackEvent("Demo Embed Opened", {
    Demo: demoId,
    Name: demoName,
  });
  trackMutinyConversion("demo-embed-opened");
  dataLayerPush("demo_embed_opened");
};

const trackDemoEmbedClosed = (demoId: string, demoName: string) => {
  trackEvent("Demo Embed Closed", {
    Demo: demoId,
    Name: demoName,
  });
  trackMutinyConversion("demo-embed-closed");
  dataLayerPush("demo_embed_closed");
};

const trackCustomerLogosClicked = (component: string, customer?: string) => {
  trackEvent("Customer Logos Clicked", {
    page: window.location.href,
    component,
    customer,
  });
};

const trackVideoPlayed = (videoId: string) => {
  trackEvent("Video Played", {
    Video: videoId,
  });
};

const trackVideoEnded = (videoId: string) => {
  trackEvent("Video Ended", {
    Video: videoId,
  });
};

const trackChangelogClicked = () => {
  trackEvent("Changelog Clicked");
};

export {
  trackDemoButtonClicked,
  trackAgentsDemoButtonClicked,
  trackDemoFormSubmitted,
  trackSignupClicked,
  trackLoginClicked,
  trackWhitepaperDownloaded,
  trackNewsletterSignup,
  trackDemoEmbedOpened,
  trackDemoEmbedClosed,
  trackCustomerLogosClicked,
  trackVideoPlayed,
  trackVideoEnded,
  trackChangelogClicked,
};
